<template>
    <div class="q-pa-md col column overflow-hidden">
        <track-editor-canvas v-if="props.event" :event-id="props.event.id" :course-title="courseTitle" class="col" />
    </div>
</template>

<script setup lang="ts">
import TrackEditorCanvas from "@/components/parts/TrackEditorCanvas.vue"
import Event from "@model/Event"
import { useRoute } from 'vue-router'
import { computed } from 'vue'

interface Props {
    event: Event
}

const props = defineProps<Props>()
const route = useRoute()

const courseTitle = computed( () => route.params.course as string )
</script>

<style lang="sass" scoped>
</style>
